import React from 'react';

import { Maybe } from 'types/graphql-api.generated';

import { PartialTheater } from 'common/components/ShowtimeModal/types';
import { IMAGE_EMPTY_PHOTO_LANDSCAPE } from 'common/configuration/constants';
import { getImageUrl } from 'common/tools/network/url';

import styles from './styles.module.scss';

type TheaterCoverProps = { theater?: Maybe<PartialTheater> };

const TheaterCover = ({ theater }: TheaterCoverProps) => {
  const theater_img_src = getImageUrl({
    src: theater?.poster?.path || IMAGE_EMPTY_PHOTO_LANDSCAPE, // landscape because thumbnail will be a square
    format: { rw: 64, rh: 64 }
  });

  return (
    <div className={styles.theaterCover}>
      <img
        className={styles.theaterPoster}
        src={theater_img_src}
        alt={theater?.name ?? undefined}
      />
      <div className={styles.theaterInfo}>
        <div className={styles.theaterName}>{theater?.name}</div>
        <div className={styles.theaterAddress}>
          {theater?.location?.address}
        </div>
        <div className={styles.theaterAddress}>
          {theater?.location?.zip} {theater?.location?.city}
        </div>
      </div>
    </div>
  );
};

export default TheaterCover;
